
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		let body 		= $( 'body' );
		let header 		= $( 'header' );

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear();
		$("#copyright-year").text(copyrightYear);

		/**
		 * Testimonial - Set equal heights
		 */
		function testimonialEqualHeights() {
			$('.testimonial-large-block, .testimonial-block').each(function () {
				var items 		= $('.carousel-item', this);
				let maxHeight 	= 0;

				// Show all slides
				$.each( items, function( i, slide ) {
					$( slide ).addClass( 'active' );
				});

				// Get the height of the tallest caption and save it
				$.each( items, function() {
					let caption 		= $('.card-body', this);
					let captionHeight 	= caption.outerHeight();

					if ( captionHeight > maxHeight ) {
						maxHeight = captionHeight;
					}
				});

				// Apply the max height to all captions
				$.each( items, function() {
					let caption = $('.card-body', this);
					caption.css( 'height', maxHeight );

					// Remove .active from all slides
					$( this ).removeClass( 'active' );
				});

				// Add the active class back to the first slide
				$('.testimonial-block .carousel-inner .carousel-item:first-of-type').addClass('active');
			});
		}
		testimonialEqualHeights();

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		let scrollPosition = 100;

		if (window.innerWidth < 992) {
			scrollPosition = 10;
		}

		if ($(window).scrollTop() > scrollPosition){
			body.addClass('sticky-header');
			header.addClass('sticky');
		} else {
			body.removeClass('sticky-header');
			header.removeClass('sticky');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > scrollPosition){
				$('body').addClass('sticky-header');
				header.addClass('sticky');
			} else {
				$('body').removeClass('sticky-header');
				header.removeClass('sticky');
			}
		});

		/**
		 * Mobile Menu - Sub menu parent item placement
		 */
		$(".mobile-menu")
			.find(".menu-item-has-children:not(.no-link) > .sub-menu")
			.each(function () {
				$(this).addClass("mobile-menu-sub-level-panel");

				let subLevelTitleElement = $(this).siblings(".nav-link").clone();

				$(this).prepend(
					$("<li>").addClass("menu-item").append(subLevelTitleElement)
				);
			});

		/**
		 * Mobile Menu - Open/close functionality
		 */
		let mobileMenuContainer 	= header.find('.mobile .menus');
		let mobileMenuBtnContainer	= header.find('.mobile .menu-button-container');
		let mobileMenuOpenBtn		= header.find('.mobile .menu-button-container button.menu-button');
		let mobileMenuCloseBtn		= header.find('.mobile .menu-button-container button.close-button');
		let mobileMenuItems			= header.find('.mobile .menus .mobile-menu .main-menu-container li:not(.menu-item-has-children) a');

		$.each(mobileMenuItems, function (i, v) {
			$(v).on('click', function() {
				mobileMenuContainer.removeClass('show');
				mobileMenuBtnContainer.removeClass('open');
				body.removeClass('menu-open');
			});
		});

		// Open
		mobileMenuOpenBtn.on('click', function () {
			mobileMenuContainer.addClass('show');
			mobileMenuBtnContainer.addClass('open');
			$('html').addClass('menu-open');
			body.addClass('menu-open');
		});

		// Close
		mobileMenuCloseBtn.on('click', function () {
			mobileMenuContainer.removeClass('show');
			mobileMenuBtnContainer.removeClass('open');
			$('html').removeClass('menu-open');
			body.removeClass('menu-open');
		});

		// Sub menus
		if (window.innerWidth < 992) {
			$.each( $('li.menu-item-has-children'), function (i, menuItem) {
				var link = $('>a.nav-link', menuItem);

				$(link).on('click', function (e){
					e.preventDefault();
					var subMenu = $('.sub-menu', menuItem);

					$(subMenu).toggleClass('sub-menu-open');
					$(link).toggleClass('sub-menu-open');
				});
			});
		}

	});
})(jQuery);